import { createRouter, createWebHistory } from "vue-router";

export const routes = [
  {
    path: "/",
    redirect: "/home",
    component: () => import("../layout/index.vue"),
    children: [
      {
        path: "/home",
        component: () => import("../views/home/index"),
        meta: {
          title: "首页",
          keepAlive: true,
        },
      },
      {
        path: "/details",
        component: () => import("../views/details/index"),
        meta: {
          title: "详情",
          keepAlive: false,
        },
      },
      {
        path: "/history",
        component: () => import("../views/history/index"),
        meta: {
          title: "观看记录",
          keepAlive: false,
        },
      },
      {
        path: "/more",
        component: () => import("../views/more/index"),
        meta: {
          title: "更多",
          keepAlive: false,
        },
      },
      {
        path: "/login",
        component: () => import("../views/login/index"),
        meta: {
          title: "登陆",
          keepAlive: false,
        },
      },
      {
        path: "/search",
        component: () => import("../views/search/search"),
        meta: {
          title: "搜索",
          keepAlive: false,
        },
      },
      {
        path: "/customer-service",
        component: () => import("../views/customerService/index"),
        meta: {
          title: "客服",
          keepAlive: false,
          showFooter: false,
        },
      },
    ],
  },
  // 匹配不到重定向会主页
  // {
  //   // 找不到路由重定向到404页面
  //   path: "/:pathMatch(.*)",
  //   redirect: "/",
  // },
];

export default createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { left: 0, top: 0 };
  },
  routes,
});
